<template>
    <form class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '上傳擋案'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-if="content.html" v-html="content.html"></div>
                    <div class="md">
                        <div class="cp input file" :class="[errors.has('file')? 'is-error': '']" :data-error="errors.first('file')">
                            <label v-if="hideLabel !== true" v-html="showLabel"></label>
                            <input
                                ref="input"
                                type="file"
                                v-validate="content.validate || ''"
                                name="file"
                                :accept="content.accept"
                                :multiple="content.multiple"
                                @change="returnFile"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                styleSet: $styleSet,
                file: null
            }
        },
        computed: {
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                $results.push($cancel);

                return $results;
            },
            label: function(){
                let $content = this.content || {},
                    _label = $content.label || '';

                return _label;
            },
            hideLabel: function(){
                let $content = this.content || {},
                    _hideLabel = $content.hideLabel || false;

                return _hideLabel;
            },
            showLabel: function(){
                let _label = this.label;

                if( _label ) {
                    return _label;
                }else {
                    return '檔案';
                }
            },
        },
        methods: {
            returnFile: function(evt){
                this.$set(this, 'file', evt.target.files);
            },
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content,
                    $file = this.file;

                $content[func]($file);
            },
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            $_action = $content.action,
                            $file = this.file;

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }

                        $_action($file);
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .pop-up-content {

        .md {

            + .md {
                margin-top: 6px;
            }
        }
    }

    .input {
        width: 100%;
    }
</style>
